/**
 * @file 首页常量
 */

import {CreationEntry, type CreationEntryType} from './interface';

/**
 * 创作入口卡片的埋点标识
 */
export const CREATION_CARD_TYPE = {
    [CreationEntry.AI_DRAMA]: 'ai_drama_card',
    [CreationEntry.SCRIPT]: 'script_card',
    [CreationEntry.MATERIAL]: 'material_card',
} as const satisfies Record<CreationEntryType, string>;
